import { useCallback } from "react";
import { useHttpAdapter } from "./useHttpAdapter";
import {
  ContentFocus,
  ContentMode,
  GenerateCampaignResponse,
} from "../types/creator-studio";
import { getApiErrorMessage } from "../utils/api-error";
import { dispatchBillingPlanRefresh } from "../utils/billing-plan-events";

export interface GenerateCampaignOptions {
  additionalInstructions?: string;
  regenerationFeedback?: string;
  targetTone?: string;
  templateId?: string;
  templateLabel?: string;
  templateInstruction?: string;
}

export const useCreatorStudioApi = () => {
  const { post } = useHttpAdapter();

  const generateCampaign = useCallback(
    async (
      prompt: string,
      brandId: string,
      selectedKnowledge: string[],
      mode: ContentMode = ContentMode.SOCIAL,
      contentFocus: ContentFocus = ContentFocus.ABOUT_PRODUCT,
      options: GenerateCampaignOptions = {}
    ) => {
      try {
        const payload = {
          topic: prompt,
          mode: mode,
          brand_id: brandId,
          knowledge: selectedKnowledge,
          content_focus: contentFocus,
          additional_instructions:
            options.additionalInstructions?.trim() || undefined,
          regeneration_feedback:
            options.regenerationFeedback?.trim() || undefined,
          target_tone: options.targetTone?.trim() || undefined,
          template_id: options.templateId?.trim() || undefined,
          template_label: options.templateLabel?.trim() || undefined,
          template_instruction:
            options.templateInstruction?.trim() || undefined,
        };

        const response = await post<GenerateCampaignResponse>(
          "/generate",
          payload
        );

        if (response.data?.status === "success") {
          dispatchBillingPlanRefresh();
        }

        return response.data;
      } catch (error) {
        console.error(error);
        return {
          status: "error",
          drafts: [],
          research: getApiErrorMessage(error, "Failed to generate content."),
        };
      }
    },
    [post]
  );

  return { generateCampaign };
};

export default useCreatorStudioApi;
